/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
const gtmId = process.env.REACT_APP_GTM_ID;
const GTM_SCRIPT_ID = "gtm-script";

type TDataLayerEvent = {
  "gtm.start": number;
  event: string;
};

declare global {
  interface Window {
    dataLayer: Array<TDataLayerEvent | Record<string, unknown>>;
  }
}

export const InitializeTagManager = () => {
  if (
    !gtmId ||
    typeof window === "undefined" ||
    typeof document === "undefined"
  ) {
    return;
  }

  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://googletagmanager.com/gtm.js?id=${gtmId}`;

  document.head.appendChild(script);
};
